import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import { App } from "./App";
import { syncWorker } from "@/lib/sync";
import "./styles/index.css";

// The sync worker runs for the life of the tab, independently of React, so a
// re-render can never interrupt an upload in progress.
syncWorker.start();

// O-01: offer the new build rather than swapping it underneath someone who is
// halfway through entering an isolate.
const updateSW = registerSW({
  onNeedRefresh() {
    if (window.confirm("A new version is available. Reload now?")) {
      void updateSW(true);
    }
  },
});

const container = document.getElementById("root");
if (!container) throw new Error("No #root element in index.html");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
